/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  GetLedgerBalancesSelfStatus200,
  GetLedgerBalancesSelfStatus400,
  GetLedgerBalancesSelfStatus404,
  GetLedgerBalancesSelfStatus500,
} from '../types/GetLedgerBalancesSelf'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { getLedgerBalancesSelf } from '../clients/getLedgerBalancesSelf'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getLedgerBalancesSelfQueryKey = () => [{ url: '/v1/ledger/balances/self' }] as const

type GetLedgerBalancesSelfQueryKey = ReturnType<typeof getLedgerBalancesSelfQueryKey>

export function getLedgerBalancesSelfQueryOptions(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const queryKey = getLedgerBalancesSelfQueryKey()
  return queryOptions<
    GetLedgerBalancesSelfStatus200,
    ResponseErrorConfig<
      | GetLedgerBalancesSelfStatus400
      | GetLedgerBalancesSelfStatus404
      | GetLedgerBalancesSelfStatus500
    >,
    GetLedgerBalancesSelfStatus200,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getLedgerBalancesSelf({
        ...config,
        signal: config.signal ?? signal,
        throwOnError: true,
      }).unwrap()
    },
  })
}

/**
 * @summary Get your own available, locked, and borrowed assets
 * {@link /v1/ledger/balances/self}
 */
export function useGetLedgerBalancesSelf<
  TData = GetLedgerBalancesSelfStatus200,
  TQueryData = GetLedgerBalancesSelfStatus200,
  TQueryKey extends QueryKey = GetLedgerBalancesSelfQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetLedgerBalancesSelfStatus200,
        ResponseErrorConfig<
          | GetLedgerBalancesSelfStatus400
          | GetLedgerBalancesSelfStatus404
          | GetLedgerBalancesSelfStatus500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? getLedgerBalancesSelfQueryKey()

  const queryResult = useQuery(
    {
      ...getLedgerBalancesSelfQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetLedgerBalancesSelfStatus400
      | GetLedgerBalancesSelfStatus404
      | GetLedgerBalancesSelfStatus500
    >
  > & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
